import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import React from 'react';
import { Field, NumericInput, TextInput, TextOutput } from '../../../../Core';
import { ListFieldSection } from '../../../../Layout';
import { WorksheetBalanceFieldSet } from '../../../Core/WorksheetEquipment';

let AsLinearShrinkageSampleMassSection: React.FC = () => {
  return (
    <>
      <ListFieldSection>
        <WorksheetBalanceFieldSet name="Preparation.Balance" />
      </ListFieldSection>
      <ListFieldSection>
        <Field input={<TextInput />} name="Preparation.TareId" maxLength={20} />
        <Field input={<NumericInput />} name="Preparation.TareMass" />
        <Field input={<NumericInput />} name="Preparation.TareAndSampleMass" />
      </ListFieldSection>
      <ListFieldSection>
        <Field input={<TextOutput />} name="Preparation.PreparedSampleMass" />
      </ListFieldSection>
    </>
  );
};

AsLinearShrinkageSampleMassSection = withInjectedProps(AsLinearShrinkageSampleMassSection);

export { AsLinearShrinkageSampleMassSection };
export default AsLinearShrinkageSampleMassSection;
